import { createStore } from 'vuex'

export default createStore({
  state: {
    userName:'',
    persons:null,
    categories:null,
    languages:null,
    courses:null,
    techCourses:null,
    getCourses:false,
    teachers:null,
    getTeachers:false
    
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
